import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPencil2"><Path d="M18.249 11.6638L9.48633 20.4284L2.25781 21.7429L3.57227 14.5143L12.335 5.74969L18.249 11.6638Z" fill="currentColor"/><Path d="M14.543 3.54266C16.1761 1.90977 18.8239 1.90977 20.457 3.54266C22.0901 5.17576 22.09 7.82354 20.457 9.45673L19.6631 10.2497L13.749 4.33563L14.543 3.54266Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil2;
